import React from 'react';
import PropTypes from 'prop-types';
import AppSpinner from './AppSpinner';
import styles from './PrimaryButton.module.css';

function PrimaryButton({
  text,
  onClick,
  loading = false,
  disabled = false,
  size = 'medium',
  fullWidth = false,
  className = '',
  type = 'button',
  ariaLabel,
}) {
  const handleClick = (e) => {
    if (loading || disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  const buttonClassName = [
    styles.primaryButton,
    styles[size],
    fullWidth && styles.fullWidth,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={buttonClassName}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-label={ariaLabel}
      aria-busy={loading}
    >
      {loading ? (
        <>

         טוען...
        </>
      ) : (
        text
      )}
    </button>
  );
}

PrimaryButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  ariaLabel: PropTypes.string,
};

export default PrimaryButton;

